export default __webpack_public_path__ + "static/media/adobe-stock-204554418-preview.a46693ac.png";